import {
  createScopedUiRepository,
  type ScopedStoredRecord,
} from "@/storage/scopedUiRepository";
import { UI_COMPONENTS_STORE } from "@/storage/uiDatabase";
import type { UiComponent } from "@/types/ui";

export interface StoredUiComponent extends UiComponent, ScopedStoredRecord {}

export const EMPTY_UI_COMPONENTS: readonly StoredUiComponent[] =
  Object.freeze([]);

const uiComponentsRepository = createScopedUiRepository<
  UiComponent,
  StoredUiComponent
>({
  emptySnapshot: EMPTY_UI_COMPONENTS,
  sortRecords: sortUiComponents,
  storeName: UI_COMPONENTS_STORE,
});

export const getUiComponentsSnapshot = uiComponentsRepository.getSnapshot;
export const subscribeUiComponents = uiComponentsRepository.subscribe;
export const hydrateUiComponents = uiComponentsRepository.hydrate;
export const replaceUiComponents = uiComponentsRepository.replace;
export const clearUiComponents = uiComponentsRepository.clear;
export const upsertUiComponent = uiComponentsRepository.upsert;
export const upsertUiComponents = uiComponentsRepository.upsertMany;
export const removeUiComponent = uiComponentsRepository.remove;
export const removeUiComponents = uiComponentsRepository.removeMany;

function sortUiComponents<T extends UiComponent>(components: readonly T[]): T[] {
  return [...components].sort((a, b) => (
    a.name.localeCompare(b.name)
    || a.uuid.localeCompare(b.uuid)
  ));
}
